import { pathOr } from 'ramda'
import { useSelector } from 'react-redux'
import { WidgetAlignment } from 'shared/constants/frames'

const useWidgetAlignment = () => useSelector(state => pathOr(WidgetAlignment.RIGHT, ['embed', 'configuration', 'theme', 'alignment'], state))

export default useWidgetAlignment
